var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":"","flat":""}},[_c('v-spacer'),_c('v-btn',{attrs:{"text":"","to":"/"}},[_vm._v(" Dashboard ")]),_c('v-btn',{attrs:{"text":"","to":"/users"}},[_vm._v(" Users ")]),_c('UserMenu')],1),_c('v-main',[_vm._t("default")],2)],1):_c('v-app',[_c('div',[_vm._v("loading ...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }